import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { useIntl } from "react-intl";
import ListaAtividadesEncadeadas from "../components/ListaAtividadesEncadeadas/ListaAtividadesEncadeadas";
import { Flex } from "../../../../_common";

function ModalAtividadesEncadeadas({
  classes,
  open,
  close,
  excluirNaoEncadeada,
  excluirComEncadeada,
  leadsAtividades,
  isSomenteEncadeadas,
}) {
  const intl = useIntl();
  return (
    <Dialog open={open} onClose={() => close(false)}>
      <DialogTitle>{intl.formatMessage({ defaultMessage: "Atividades excluídas encadeadas à workflow" })}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography variant="body1" className={classes.subtitulo}>
            {intl.formatMessage({
              defaultMessage:
                "As atividades abaixo estão encadeadas à outras atividades do workflow, se escolher excluir todas, as atividades encadeadas serão removidas. As demais ações do workflow serão mantidas.",
            })}
          </Typography>
          {leadsAtividades?.map(atividades => (
            <>
              <ListaAtividadesEncadeadas atividadesLead={atividades} />
            </>
          ))}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => close(false)}>{intl.formatMessage({ defaultMessage: "Cancelar" })}</Button>
        <Tooltip
          title={intl.formatMessage({
            defaultMessage: "Sem atividades não encadeadas",
          })}
          disableHoverListener={!isSomenteEncadeadas}
          disableFocusListener={!isSomenteEncadeadas}
          disableTouchListener={!isSomenteEncadeadas}
        >
          <Flex>
            <Button color="primary" onClick={excluirNaoEncadeada} disabled={isSomenteEncadeadas}>
              {intl.formatMessage({ defaultMessage: "Excluir não encadeadas" })}
            </Button>
          </Flex>
        </Tooltip>
        <Button color="primary" variant="contained" onClick={excluirComEncadeada}>
          {intl.formatMessage({ defaultMessage: "Excluir todas" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalAtividadesEncadeadas.propTypes = {
  classes: PropTypes.object,
  open: PropTypes.bool,
  close: PropTypes.func,
  excluirNaoEncadeada: PropTypes.func,
  excluirComEncadeada: PropTypes.func,
  leadsAtividades: PropTypes.object,
  isSomenteEncadeadas: PropTypes.bool,
};

export default withStyles({
  subtitulo: {
    marginBottom: 24,
  },
})(ModalAtividadesEncadeadas);
